import { t } from '@lingui/macro';

import { Actions, Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import Link from '../../links/Link';
import { JumpSettings as JumpSettingsIcon } from '../../icon/Icons';
import { useIsAdminUser } from '../../../stores/SessionStore';
import { ServerFilter, TimeRangeFilter, useServer, serverFilterId } from '../../filters';
import { useSummarizedFilterStateById } from '../../../stores/FilterStateStore';
import { LAYOUT_WIDTH } from '../../page-framework/panel-container/PanelContainer';
import {
    ServerStatusPanel,
    ServerCpuUtilizationPanel,
    ServerMemoryUtilizationPanel,
    ServerDiskUtilizationPanel,
    ServerDiskIOPanel,
    ServerNetworkUtilizationPanel,
    ServerProcessPanel,
    ServerPropertiesPanel,
    ServerSyslogPanel,
} from '../../panels';

export const pageId = 'server-detail';

export default function ServerDetailPage() {
    const server = useServer();
    const [summarized] = useSummarizedFilterStateById(serverFilterId);
    const title = summarized?.value;
    const [isAdminUser] = useIsAdminUser();

    return (
        <Page id={pageId}>
            <PageHeader
                title={title}
                titleActions={
                    server &&
                    !server.deleted &&
                    isAdminUser && (
                        <Actions>
                            <Link
                                to={`/admin/monitored-infrastructure/${server?.uuid}`}
                                title={t`Edit server configuration`}
                            >
                                <JumpSettingsIcon fontSize="small" />
                            </Link>
                        </Actions>
                    )
                }
            >
                <FilterContainer>
                    <TimeRangeFilter required />
                    <ServerFilter required />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <ServerStatusPanel width={LAYOUT_WIDTH.FULL} title={t`Status`} />
                <ServerCpuUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`CPU Utilization`} />
                <ServerMemoryUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Memory Utilization`} />
                <ServerDiskUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Disk Utilization`} />
                <ServerDiskIOPanel width={LAYOUT_WIDTH.HALF} title={t`Disk I/O`} />
                <ServerNetworkUtilizationPanel width={LAYOUT_WIDTH.HALF} title={t`Network I/O Utilization`} />
                <ServerProcessPanel width={LAYOUT_WIDTH.HALF} title={t`Processes`} />
                <ServerSyslogPanel width={LAYOUT_WIDTH.FULL} title={t`Syslog Events`} />
                <ServerPropertiesPanel width={LAYOUT_WIDTH.FULL} title={t`Properties`} />
            </PanelContainer>
        </Page>
    );
}
